import React from 'react'
import {BorderlessButtonLight} from '../unilink/index'
import './headerNav.css'

class HeaderNav extends React.PureComponent {
  render() {
    const {className, tabs, activeTab, centered, scrolling} = this.props
    const classNames = ['header-nav',className]
    if (centered) {
      classNames.push('header-nav--centered')
    }
    if (scrolling) {
      classNames.push('header-nav--scrolling')
    }
    return (
      <nav className={classNames.join(' ')}>
        {
          Object.keys(tabs).map((route) => {
            return (
              <BorderlessButtonLight
                key={route}
                to={{
                  pathname:route,
                  state: {
                    noScrollRestoration: true
                  }
                }}
                className={activeTab===tabs[route] ? ['header-nav__tab','header-nav__tab--active'].join(' ') : 'header-nav__tab'}
              >
                {tabs[route]}
              </BorderlessButtonLight>
            )
          })
        }
      </nav>
    )
  }
}

export default HeaderNav



// WEBPACK FOOTER //
// ./src/core/components/header-nav/HeaderNav.js